var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg18 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "18")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M80.46,13.9a11.35,11.35,0,0,0-2.55-1.67C72.7,9.5,67,8.62,61.27,7.83c-2.73-.37-5.51-.19-8.24-.58H36.37a.86.86,0,0,1-.63.18A70.09,70.09,0,0,0,20.45,9.25a28.47,28.47,0,0,0-10.17,4.11c-3,2.13-3.29,5-.74,7.61a36.24,36.24,0,0,1,3.06,3.85c7.22,9.79,14.32,19.68,21.6,29.43a8.45,8.45,0,0,1,1.76,5.48c-.1,7.19,0,14.38,0,21.57a3.35,3.35,0,0,0,.45,2.44h2a8.64,8.64,0,0,0,1.52-1.06Q46.47,76.13,53,69.6a3.6,3.6,0,0,0,1.13-2.73c0-2.26.13-4.54,0-6.79a8.8,8.8,0,0,1,2-6.23c5.58-7.42,11-15,16.48-22.44,2.76-3.73,5.29-7.62,8.44-11.05C82.95,18.31,82.63,15.93,80.46,13.9Zm-2.89,5.46a25.77,25.77,0,0,1-9.49,3.41,117.15,117.15,0,0,1-48.48-.59,20.72,20.72,0,0,1-6.88-2.71c-2.1-1.38-2.12-2.61,0-3.92,3.29-2,7-2.78,10.7-3.53a110.69,110.69,0,0,1,21.61-1.86c9.18.06,18.3.65,27.18,3.24a17.76,17.76,0,0,1,5.38,2.38C79.37,17,79.35,18.2,77.57,19.36Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg18, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/18.e3552fb1.svg";
export { ForwardRef as ReactComponent };